import { useState } from "react";
import CheckBox from "../../../../../../../Components/CheckBox/CheckBox";
import ModalWindow from "../../../../../../../Components/ModalWindow/ModalWindow";
import ScpPermissions from "../../../../../../../Services/Permissions/Data/ScpPermissions";
import { CheckPermissionForEdit } from "../../../../../../../Services/Permissions/PermissionManager";
import GroupUsersRequests from "../../../../../../../Services/Api/GroupUsersRequests.ts";

const EditUserModal = ({editUser, hide, refresh}) => {
    const groupUsersRequests = new GroupUsersRequests();

    const [permission, setPermission] = useState(editUser.permissions);

    const Edit = () => {
        const data = {
            Permissions: permission,
            UserToServerGroupId: editUser.id,
        }

        groupUsersRequests.Edit(data, () => {
            refresh();
            hide();
        })
    }

    return (
        <ModalWindow 
        title={"Dodaj użytkownika do grupy"}
        minWidth={"60%"}
        buttons={[
            { Text: "Edytuj", onClick: () => { Edit() }},
            { Text: "Anuluj",  onClick: () => { hide() }, className: "modalSecondaryBtn" }
        ]}
        content={
            <>
                <h2 className="mb-5">Uprawnienia</h2>
                <div className="columns-2 mb-20">
                    { Object.values(ScpPermissions).filter(x => !x.hidden).map(permissionData => 
                        <CheckBox 
                            value={CheckPermissionForEdit(permission, permissionData.value)} 
                            text={permissionData.text} 
                            onChange={() => {
                                if(CheckPermissionForEdit(permission, permissionData.value))
                                    setPermission(permission - permissionData.value)
                                else
                                    setPermission(permission | permissionData.value)
                            }}
                        />
                    )}
                </div>                 
            </>
        }
    />
    )
}

export default EditUserModal;